import { genericAPICall } from 'api-setup/api-helper';
import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { SSO_AUTH_LOGIN } from '../../api-setup/api-endpoints.js';
import { setNewMessage } from 'redux/actions/setting-actions';
import { useDispatch } from 'react-redux';
import { API } from 'api-setup/api-helper';
import { setUserCredential, setOnboardingDataCollectionDone } from 'lib/cookies.js';
import { downTimeModalAction } from 'pages/DownTime/downTimeReducer';
import { setUserInfo } from 'redux/actions/user-action.js';
import usePosthogClient from 'lib/posthog/usePosthogClient';
import Box from '@material-ui/core/Box';
import { CircularProgress } from '@material-ui/core';

const SSOLogin = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();
    const payload = params && params?.payload && JSON.parse(decodeURIComponent((params.payload)));
    const { identifyOrgData } = usePosthogClient();

    useEffect(() => {
        if(payload){
           genericAPICall(SSO_AUTH_LOGIN, 'POST', {
            data: {
              ...payload,
            },
          }).then((res) => {
              if (res.data.status === API.apiSuccessStatus) {
                const { token, userData, team_member_id, isOnboardingDataCollectionDone, organiser_id, isFirstLogin } =
                  res.data.data;
                if (isFirstLogin) {
                  history.push({
                    pathname: '/set-password',
                    state: {
                      organiser_id,
                      token,
                      email: userData?.email,
                    },
                  });
                } else {
                  setOnboardingDataCollectionDone(
                    isOnboardingDataCollectionDone,
                    'isOnboardingDataCollectionDone'
                  );
                  dispatch(downTimeModalAction(true)); // DOWNTIME MODAL ACTION TRIGGER
                  setUserCredential(
                    {
                      authToken: token,
                      teamMemberId: team_member_id,
                      organiser_id,
                      userPermission: userData.userPermission,
                    },
                    'userData'
                  );
                  const resp = {
                    userData,
                    isFirstLogin,
                    isOnboardingDataCollectionDone,
                  };
                  const userInfo = resp.userData;
                  identifyOrgData(userInfo.email, {
                    organiser_id: userInfo.organiser_id,
                    ...(userInfo.organisation && { organisation: userInfo.organisation })
                  });
                  dispatch(setUserInfo(userInfo));
                }
              }
          }).catch((err) => {
              const message = err.response && err.response.data ? err.response.data.message : 'Some error occurred';
              dispatch(setNewMessage({ message, type: 'error', show: true }));
              history.replace('/login');
          });
        }

        
    },[]);


    return (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularProgress color="primary" size={50} />
        </Box>
    );
};

export default SSOLogin;